<template>
  <StandardDialog @click-outside="$router.push({ name: 'UserHome'})" >
    <template #content>
      <div class="images_detail">
        <HomeDashboardLoglistDetail v-for="(project, index) in checkProjects()" :key="index" style="width: 33%;">
          <template #header>
            <v-btn @click="$router.push({ name: 'Project',params: {project_id: project.id}})"> {{project.name}} </v-btn>
            <span class="dashboard-widget-badge">  {{checkImages(project.id).length}} </span>
          </template>
          <template #loglist>
            <div v-for="image_entity in checkImages(project.id)"
            :key="'invite'+image_entity.id" style="padding: 3px;"
            @click="image_entity.twork_package ? $router.push({
                name: 'TaktPlanWorkPackageInfo',
                params: {
                  project_id: image_entity.project_id,
                  train_id: image_entity.train_id,
                  taktarea_id: image_entity.taktarea_id,
                  twaggon_id: image_entity.twaggon_id,
                  tworkpackage_id: image_entity.twork_package.id,
                }
              }) : ''">
            <StandardCard
              :image="image_entity.image"
              :name="image_entity.project_name"
              :cols="12"
              >
              <template #info>
                <div style="display: flex; flex-direction: row; justify-content: center; align-items: center">
                <StandardDataField
                  class="pa-1 "
                  :header="`${image_entity.user} ${image_entity.updated.substring(0, 16)}`"
                  :value="`Comment: ${image_entity.comment}`"

                  :readonly="true"
                  width="100%"
                  :style="`background-color: #252525; color: white; margin-top: -2px; max-height: 90px; overflow: visible;

                  width: 80%;
                  `"
                  />
                  <TWorkPackage
                    v-if="image_entity.twork_package"
                    style="margin: 6px"
                    :workpackage_count="1"
                    :zoom="1"
                    :margin="3"
                    :workpackage="image_entity.twork_package"
                    />
                    <!-- <StandardCommunityPackage
                    v-if="false"
                    :color="entry.work_package.color"
                    :text_color="entry.work_package.textcolor"
                    :zoom="0.5"
                    :margin="6"
                    :height="34"
                    :width="54"
                    > -->
              <!-- <StandardCommunityPackage

              :color="image_entity.twork_package_color"
              :text_color="image_entity.twork_package_textcolor"
              :zoom="0.4"
              :margin="6"
              :height="34"
              :width="54"
              > -->
              <!-- <template #content>
                <div><svg-icon :name="image_entity.twork_package_icon"> </svg-icon> {{image_entity.twork_package_token}}</div>
              </template>
              </StandardCommunityPackage> -->
            </div>
              <!-- <p v-if="image_entity.comment != ''" style="oerflow: hidden; text-overflow: ellipsis;
              max-height: 34px"> Comment: {{image_entity.comment}} </p> -->
            <!-- </div> -->

              </template>
            </StandardCard>
          </div>
          </template>
        </HomeDashboardLoglistDetail>
      </div>
    </template>
  </StandardDialog>
</template>

<script>
import {
  mapGetters
} from 'vuex';

import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue'
import HomeDashboardLoglistDetail from '@/components/HomeDashboard/Detail/HomeDashboardLoglistDetail.component.vue'
import StandardCard from '@/components/StandardComponents/StandardCard.component.vue'
// import StandardCommunityPackage from '@/components/HomeDashboard/StandardCommunityPackage.component.vue'
import StandardDataField from '@/components/StandardComponents/StandardDataField.component.vue'
import TWorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue'
import store from '@/store/index'
export default {

components: {
  StandardDialog,
  HomeDashboardLoglistDetail,
  // StandardCommunityPackage,
  StandardDataField,
  TWorkPackage,
  // StandardTextCard,
  StandardCard
},
beforeRouteEnter (to, from, next) {
  store.dispatch('Dashboard/requestLatestImageEntities').then(() => {
    next();
  });
},

data: function() {
  return {
    projects: [],
    count: 0,
  }
},
computed: {
  ...mapGetters('Dashboard',[
    'getDashboardImagesLatest',
  ]),
},
methods: {
  LoglistItems(LoglistLatest) {
    if (LoglistLatest === 'train_start') {
      return 'train start';
    }
    if (LoglistLatest === 'TWaggon') {
      return 'waggon';
    }
    else{
      return LoglistLatest;
    }
  },
  checkImages(project_id) {
    let helper = [];
    for(let image of this.getDashboardImagesLatest) {
      if (image.project_id === project_id){
        helper.push(image);
      }
    }
    return helper;
  },
  checkProjects(){
    for (let image of this.getDashboardImagesLatest){
      let push = true;
      for (let project of this.projects){
        if (project.id === image.project_id){
          push = false;
          break;
        }
      }
      if(push){
        this.projects.push({name: image.project_name , id: image.project_id});
      }
    }
    return this.projects;
  }
}
}
</script>

<style>

.images_detail{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 3px;
  gap: 3px;
  background-color: #303030;
  min-height: 75vh;
}
.dashboard-widget-badge {
  background: white;
  border-radius: 30px;
  color: #fff;
  content: attr(badge);
  font-size: 17px;
  /* margin-top: -10px; */
  min-width: 28px;
  padding: 2px;
  position: absolute;
  text-align: center;
  margin-left: 10px;
  color: black;

}
</style>
